import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "../../../../component/button/Button";
import Input from "../../../../component/input/Input";
import Select from "../../../../component/multiSelect/MultiSelect";

const OptionSixJobFilter = (props: any) => {
    const location = useLocation();
    const routeParams = useParams();
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const langLabels = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const searchLangLabels = langLabels?.searchSection?.[0];
    const { filter, tableControl, setTableControl, searchControlSubmit } = props;

    return (
        <section className={`option6-filter ${location.pathname === `/view/${routeParams?.id}` ? "is-job-view" : ""}`}>
            <div className="option6-filter-grid">
                <div className="option6-field option6-field-search">
                    <Input
                        className="form-control option6-input"
                        type={"text"}
                        value={tableControl.searchText}
                        placeholder={searchLangLabels?.searchPlaceholder ? `${searchLangLabels?.searchPlaceholder}...` : "Search roles..."}
                        name={searchLangLabels?.search}
                        onChange={(e: { target: { value: any } }) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchText: e.target.value
                            }));
                        }}
                    />
                </div>

                <div className="option6-field">
                    <Select
                        isSearchable={true}
                        className="joblist-multi-select option6-select"
                        placeholder={searchLangLabels?.category || "All Departments"}
                        isMulti={true}
                        onChange={(e: any) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchCat: e
                            }));
                        }}
                        value={tableControl.searchCat}
                        options={filter.jobCategories || []}
                    />
                </div>

                <div className="option6-field">
                    <Select
                        isSearchable={true}
                        className="joblist-multi-select option6-select"
                        placeholder={searchLangLabels?.locations || "All Locations"}
                        isMulti={true}
                        onChange={(e: any) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchLocation: e
                            }));
                        }}
                        value={tableControl.searchLocation}
                        options={filter.jobLocations || []}
                    />
                </div>

                <div className="option6-field">
                    <Select
                        isSearchable={true}
                        className="joblist-multi-select option6-select"
                        placeholder={searchLangLabels?.jobTypes || "Job Type"}
                        isMulti={true}
                        onChange={(e: any) => {
                            setTableControl((prs: any) => ({
                                ...prs,
                                searchJob: e
                            }));
                        }}
                        value={tableControl.searchJob}
                        options={filter.jobTypes || []}
                    />
                </div>

                <div className="option6-field option6-action">
                    <Button
                        clasName="btn option6-search-btn"
                        label={searchLangLabels?.search || "Search"}
                        position="left"
                        icon="pi pi-search"
                        onClick={() => searchControlSubmit()}
                    />
                </div>
            </div>
        </section>
    );
};

export default OptionSixJobFilter;
